export const isLiveMode = process.env.REACT_APP_LIVE_MODE === 'true';

// Dynamic URLs sourced from environment configuration
export const INSPECTION_URL = process.env.REACT_APP_WP_API_URL;
export const MEDIA_UPLOAD_URL = process.env.REACT_APP_MEDIA_UPLOAD_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TOKEN_VALIDATION_URL = process.env.REACT_APP_TOKEN_VALIDATION_URL;
export const LARAVEL_BACKEND_API_URL = process.env.REACT_APP_LARAVEL_BACKEND_API_URL;
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

export const MEDIA_UPLOAD_URL_VIDEO = `${LARAVEL_BACKEND_API_URL}media`;
export const MEDIA_UPLOAD_URL_IMAGE = `${LARAVEL_BACKEND_API_URL}media`;

// Backward compatibility bindings (mapped dynamically to env configuration)
export const DEMO_URL = process.env.REACT_APP_WP_API_URL;
export const LIVE_URL = process.env.REACT_APP_WP_API_URL;
export const MEDIA_UPLOAD_URL_DEMO = process.env.REACT_APP_MEDIA_UPLOAD_URL;
export const MEDIA_UPLOAD_URL_LIVE = process.env.REACT_APP_MEDIA_UPLOAD_URL;

